<div class="page-wrapper h-100" id="page-wrapper">
  <main class="content header-fixed">
    <app-header class="sticky-top"></app-header>
    <div class="d-flex flex-column page-content-wrapper-inner">
      <app-page class="flex-grow-1 bg-light">
        <router-outlet></router-outlet>
      </app-page>
    </div>
    <app-footer></app-footer>
  </main>
</div>
